import { PremmiarEndpoint } from "../clients";

export const FetchLikePlusCard = async (User, documentNumber, finallyCallback = () => {}) => {
    try {
        const response = await PremmiarEndpoint(User).get(`/v1/focalpoint/searchCard/${documentNumber}`);
        return response.data;
    } catch (error) {
        console.info('FetchLikePlusCard Error =>', error)
    } finally {
        finallyCallback();
    }
};

export const FetchLikePlusPointsToCash = async (User, points, finallyCallback = () => {}) => {
    try {
        const response = await PremmiarEndpoint(User).get(`v1/focalpoint/pointsToMiles/${points}`);
        return response.data;
    } catch (error) {
        console.info('FetchLikePlusPointsToCash Error =>', error)
    } finally {
        finallyCallback();
    }
};

export const FetchLikePlusRedemption = async (User, payload, finallyCallback = () => {}) => {
    try {
        const response = await PremmiarEndpoint(User).post('/v1/focalpoint/orders/redemption', payload);
        return response.data;
    } catch (error) {
        console.info('FetchLikePlusFees Error =>', error)
        return error.response
    } finally {
        finallyCallback();
    }
};
